<template>
<div>
    <div v-if="loaded === false" style="width:100%; z-index:99999999999999999999999999;">
        <v-progress-linear indeterminate color="rgb(242, 117, 9)"></v-progress-linear>
    </div>

  <div v-if="mindDesign && mindLandingPage && loaded">
  <div v-if="!acceptedRules" style="width: 100%; display: flex; justify-content: center; ">
      <div class="conditions-div" :style="notAcceptedModal ? 'filter: blur(1px)' : ''">
        <header>
          <h1>Villkor</h1>
        </header>
        <div class="condition-content">
          <div class="condition-content-text">
            <h2>Vi månar om din säkerhet</h2>
            <p>Du som vänder dig till någon av Minds stödlinjer ska kunna känna dig trygg med att privata uppgifter stannar hos oss. För att vi ska kunna erbjuda dig stöd via chatt ber vi därför om ditt samtycke till att vi behandlar dina personuppgifter. Det vill säga att vi tillfälligt sparar information så som ditt namn, var du bor, hur gammal du är eller andra uppgifter som du själv valt att ange.</p>
          <p>När du hör av dig till Minds stödlinjer väljer du förstås alltid själv vad du vill berätta. Vissa nämner inte några personuppgifter alls medan andra berättar mer öppet om sig själva. För att du ska känna dig trygg att dela just så mycket information som du själv önskar har alla som tar emot stödsamtal via chatt och telefon på Mind avgett ett tystnadslöfte. Vad du säger eller skriver behandlas tryggt och i enlighet med Minds integritetspolicy som du kan läsa här: mind.se/integritetspolicy/dina-personuppgifter/#stodsokande</p>
        <p>När du även ger oss ditt samtycke att behandla dina personuppgifter innebär det att du godkänner att:</p>  
        </div>
          <ul class="conditions-list">
            <li>Mind sparar det du skrivit i chatten under tre månader. Detta gör vi för att kvalitetssäkra stödet som ges och för att utveckla Minds verksamhet med målet att ge ett ännu bättre stöd.</li>
            <li>Efter tre månader raderas alla eventuella personuppgifter från chattsamtalet så att endast information som inte kan knytas till dig som person finns kvar.</li>
          </ul>
          <div class="condition-content-text">
            <p>Du väljer själv om du vill samtycka till behandlingen av uppgifterna och du kan alltid ta tillbaka ditt samtycke genom att fylla i formuläret på mind.se/synpunkter-stöd. Se till att spara ned det unika ID-nummer du får innan du börjar chatta första gången och som du vid återtagande av samtycke kommer behöva ange. Om du inte vill ge oss samtycke kan vi inte erbjuda just chattkontakt, men du är fortfarande varmt välkommen att vända dig till någon av våra telefonlinjer istället. När du ringer till oss sparas inga personuppgifter från samtalet.</p>
            <p>Om du vill veta mer om hur Mind behandlar personuppgifter kan du läsa detta i vår integritetspolicy: mind.se/integritetspolicy</p>
            <p>Tack för din tid!</p>
            <b>Ditt ID:</b>
          </div>
            <ul class="conditions-list">
              <li>{{userGuid}}</li>
            </ul>

        </div>
          <div class="options">
                <v-checkbox
                  v-model="conditionsCheckbox"
                  label="Jag har läst och godkänner villkoren"
                  :disabled="notAcceptedModal"
                ></v-checkbox>
            <v-btn :disabled="notAcceptedModal"  color="orange" :large="!desktop" @click="acceptRules">Fortsätt</v-btn>
          </div>
      </div>
          <v-card v-if="notAcceptedModal" class="not-accepted-modal">
            <header></header>
            <div style="padding: 1em; color: #2c3e50">
              <p>Om du inte samtycker till Minds behandling av dina personuppgifter kan du få stöd av oss via telefon. När du ringer till oss sparas ingen information som kan knytas till dig. </p>
              <p><i><v-icon>mdi-phone</v-icon>+46 12 345 6789</i></p>
              <div class="modal-options" style="width: 100%;">
                <v-btn color="orange" style="width: 90%;" href="http://www.mind.se">Gå till Mind.se</v-btn>
                <v-btn color="orange" style="width: 90%; margin-top: 5px" @click="notAcceptedModal = !notAcceptedModal">Stäng ruta</v-btn>
              </div>
            </div>
          </v-card>
  </div>

    <div v-if="acceptedRules">
       <h1 class="mt-5 mb-5" style="font-size: 3em">
      <span v-if="iHaveASlot === true">Välkommen!</span>
      <span v-else-if="isChatOpen === false">Chatten är tyvärr full!</span></h1>
      <span>
        <div id="wrapper-chat-message" v-if="iHaveASlot === true">
          <p style="font-size: 1.5em; margin-bottom: 5px">Vi chattar med dig så fort vi kan.</p>
          <p style="font-size: 1.5em">Tack för att du väntar</p>
          <p style="color:red;">Lämna inte denna sida för då förlorar du din kö-plats</p>

          <p v-if="quitChatInQueue" style="color:red;">Du har förlorat din kö-plats på grund av att du lämnade denna sida<br>
            <a href="http://mind.se/chatta" target="blank">Tryck här för att försöka igen</a>
          </p>
        </div>
        <div v-else-if="dailyLimitReached"> 
          <p style="font-size: 1.5em; margin-bottom: 5px" v-if="loaded">
            Mind erbjuder alla stödsökande tre chattsamtal per dygn. Om du önskar ytterligare stöd än de tre samtal du fått under det här dygnet är du välkommen att höra av dig till oss igen imorgon. Om du befinner dig i en akut kris, ring 112.
          </p>
        </div>
        <div v-else> 
          <p style="font-size: 1.5em; margin-bottom: 5px" v-if="loaded">
            Stäng denna sida och försök igen.
          </p>
        </div>
      </span>

    <div class="qiut-btn-container" v-if="iHaveASlot === true">
      <v-col cols="auto">
        <v-dialog
          transition="dialog-bottom-transition"
          max-width="300"
        >
          <template v-slot:activator="{ on, attrs }">
            <hr class="hr-for-qiut-btn-container" />
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="#f27509"
              class="qiut-btn"
              >Avsluta</v-btn
            >
          </template>
          <template v-slot:default="dialog">
            <v-card height="180px" class="pt-8">
              <h3>Är du säker på att du vill avsluta?</h3>
              <v-card-actions class="sure-to-quit-card">
                <v-btn
                  x-large
                  color="#f27509"
                  @click="closePopupLeavPage()"
                  class="text-capitalize"
                  style="color: white"
                  >Ja</v-btn
                >
                <v-btn
                  @click="dialog.value = false"
                  x-large
                  color="#f27509"
                  class="text-capitalize"
                  style="color: white"
                  >Nej</v-btn
                >
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-col>
      </div>
    </div>
  </div>
  <div v-else-if="loaded" @click="handleDocumentClick($event)">    
    <div
      v-if="error && chatQuit != 1"
      style="width: 100%; font-size: 11px; margin-top: 20px; color: red"
    >
      Något är fel med uppkopplingen...
    </div>
    <div
      v-else-if="!error && !mindDesign"
      style="width: 100%; font-size: 11px; margin-top: 10px"
    >
      <span
        v-if="!addContactInfo"
        @click="callClosePopup()"
        class="material-icons"
        style="
          float: right;
          margin-right: 10px;
          font-size: 30px;
          cursor: pointer;
        "
        >close</span
      >
    </div>
    <div v-else class="header-logo-mind">
      <div class="mind-logo-container">
        <img
          src="../assets/mind-logo-cut.jpg"
          alt="MIND För Psykisk Hälsa"
          style="height: 100%; width: 100%"
        />
      </div>
    </div>
    <div
      id="chatWindow"
      :class="changableChatMessageWindow"
      v-if="!addContactInfo"
    >
      <div v-if="mindDesign">
        <div v-for="(item, i) in messageObject" :key="i">
          <div style="width: 100%; float: right" v-if="item.from != 'agent'">
            <div style="width: 100%">
              <pre style="display: flex; flex-direction: column; align-items: flex-end; padding-right: 15px;">
                <div class="mr-3" style="font-size: 10px; color: grey;" >{{getOnlyTime(item.dateTime)}}</div>
                <div class="message-from-visitor-mind" v-html="item.message"></div>
              </pre>
            </div>
          </div>
          <div style="width: 100%; float: left" v-else>
            <div style="width: 100%; float: left">
              <pre style="display: flex; flex-direction: column; align-items: flex-start; padding-left: 15px;">
                <div class="ml-3" style="font-size: 10px; color: grey;" v-if="i != 0">{{getOnlyTime(item.dateTime)}}</div>
                <div class="message-from-agent-mind" v-html="item.message"></div>
              </pre>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-for="(item, i) in messageObject" :key="i">
          <div style="width: 100%; float: right" v-if="item.from != 'agent'">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div style="width: 100%">
                  <pre style="display: flex; flex-direction: column; align-items: flex-end; padding-right: 15px;">
                    <div v-on="on" class="message-from-visitor" v-html="item.message"></div>
                  </pre>
                </div>
              </template>
              <span >{{ item.dateTime | moment }} {{ "Från: Visitor" }} </span>
            </v-tooltip>
          </div>
          <div style="width: 100%; float: left" v-else>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div style="width: 100%; float: left">
                  <pre style=" display: flex; flex-direction: column; align-items: flex-start; padding-left: 15px;">
                    <div v-on="on" class="message-from-agent" v-html="item.message"></div>
                  </pre>
                </div>
              </template>
              <span>
                {{ item.dateTime | moment }}
                {{ "Från: " + item.agentFullName }}
              </span>
            </v-tooltip>
          </div>
        </div>
      </div>
      <div style="width: 100%; padding-left: 20px" v-if="agentIsWriting">
        <div style="width: 100px; height: 100px">
          <img
            src="../assets/illustrations/isTyping.gif"
            alt="Skriver..."
            style="width: 100%; height: 100%"
          />
        </div>
      </div>
    </div>

    <div
      class="message-creation-container"
      v-if="!addContactInfo && !mindDesign"
    >
      <span class="message-creation-textarea-container">
        <v-textarea
          class="message-creation-textarea"
          :disabled="disableSendField || error"
          label="Ditt meddelande"
          color="#006eb0"
          autocomplete="off"
          rows="1"
          filled
          no-resize
          ref="messageRef"
          @focus="scroll()"
          v-model="messageFromVisitor"
          @keyup="sendKeyUp"
          @keydown="sendKeyDown"
        ></v-textarea>
      </span>

      <span class="message-creation-send-btn">
        <v-icon
          style="display: none; transform: rotate(-50deg); font-size: 20px"
          @click="sendMessage(userObject)"
          color="#006eb0"
          >send</v-icon
        >
        <v-btn
          elevation="2"
          color="green"
          dark
          v-bind:medium="width > 350"
          v-bind:x-small="width < 350"
          :style="width > 350 ? 'margin-top: 8px' : 'margin-top: 15px'"
          rounded
          @click="sendMessage(userObject)"
          >Skicka</v-btn
        >
      </span>
    </div>
    <div
      class="message-creation-container-mind"
      v-if="chatQuit == 0"
    >
      <!-- <hr class="mb-2" /> -->
      <span class="message-creation-textarea-container-mind">
        <v-textarea
          class="message-creation-textarea-mind"
          :disabled="disableSendField || error"
          label="Ditt meddelande"
          color="#006eb0"
          autocomplete="off"
          rows="1"
          filled
          hide-details="felse"
          no-resize
          :height="height > 490 ? 135 : 65"
          ref="messageRef"
          @focus="scroll()"
          v-model="messageFromVisitor"
          @keyup="sendKeyUp"
          @keydown="sendKeyDown"
          style="caret-color: #f27509 !important; color: #f27509 !important"
        ></v-textarea>
      </span>
      <div class="message-creation-btn-container-mind">
        <span>
          <v-col cols="auto">
            <v-dialog
              transition="dialog-bottom-transition"
              max-width="300"
              v-model="dialog1"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="#f17509"
                  v-bind="attrs"
                  v-on="on"
                  class="back-to-home-btn-mind"
                  text
                  >Avsluta</v-btn
                >
              </template>
              <template v-slot:default="dialog1">
                <v-card height="180px" class="pt-8">
                  <h3>Vill du verkligen avsluta?</h3>
                  <v-card-actions class="sure-to-quit-card">
                    <v-btn
                      x-large
                      color="#f27509"
                      style="color: white"
                      @click="quitChat()"
                      class="text-capitalize"
                      >Ja</v-btn
                    >
                    <v-btn
                      @click="dialog1.value = false"
                      x-large
                      color="#f27509"
                      style="color: white"
                      class="text-capitalize"
                      >Nej</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </template>
            </v-dialog>
          </v-col>
        </span>
        <div>
          <v-btn @click="emojiShow = true" icon color="#0c9896" id="emojiToggleBtn"
            ><v-icon id="emojiToggleIcon">mdi-emoticon-happy-outline</v-icon>
          </v-btn>
          <div
            v-if="emojiShow == true"
            class="emoji-picker-container"
            style="position: fixed; top: 0; right: 0"
          >
            <emoji-picker
              id="emoji-picker-chatcode"
              v-on:emoji-click="emojiEvent($event)"
            ></emoji-picker>
          </div>
          <span class="message-creation-send-btn-mind">
            <v-icon
              style="display: none; transform: rotate(-50deg); font-size: 20px"
              @click="sendMessage(userObject)"
              color="#006eb0"
              >send</v-icon
            >
            <v-btn
              elevation="2"
              color="#f27509"
              dark
              @click="sendMessage(userObject)"
              >Skicka</v-btn
            >
          </span>
        </div>
      </div>
    </div>
    <div
      v-if="chatQuit === 1"
      style="width: 100%"
      class="d-flex justify-center mb-6"
    >
      <v-card
        elevation="3"
        width="95%"
        :style="width > 400 ? 'height: 120px' : 'height: 160px'"
        color="#ffe7c4"
      >
        <v-list-item>
          <v-list-item-content class="justify-center">
            <v-list-item-title
              class="text-h4"
              style="font-size: 24px; margin-bottom: 8px"
            >
              Tack för ditt samtal!
            </v-list-item-title>
            <v-list-item-subtitle>
              Chatten är nu avslutad. <br />
              Du kan läsa chatten eller stänga chattfönstret.
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-card-actions class="justify-center" style="padding: 0px">
          <v-btn color="#f27509" style="color: white; display:block;" @click="callClosePopup()"
            >Stäng chattfönstret</v-btn
          >
        </v-card-actions>
      </v-card>
    </div>
  </div>
  <Survey v-if="caseId !== 0" :caseId="caseId" :key="caseId"/>

</div>

</template>

<script>
import moment from "moment";
import presenceColor from "@/plugins/presence";
import ScreenShare from "./ScreenShare";
import Survey from "./Survey";
import config from "../api/config";

export default {
  name: "app",
  props: ["user", "booking"],
  data() {
    return {
      userGuid: localStorage.getItem('___user-guid'),
      notAcceptedModal: false,
      conditionsCheckbox: false,
      acceptedRules: true, // TODO: should be set to false if consent is implemented
      dailyLimitReached: false,
      valid: false,
      lazy: false,
      userObject: "",
      messageFromVisitor: "",
      visitorId: localStorage.getItem("visitorId"),
      rand: localStorage.getItem("rand"),
      messageObject: {},
      dialog: false,
      addContactInfo: Boolean,
      visitorEmail: "",
      visitorClientNumber: "",
      visitorInfo: {},
      rulesEmail: [
        (v) => !!v || "Du måste skriva en e-post",
        (v) => /.+@.+\..+/.test(v) || "E-posten är inte korrekt.",
      ],
      rulesClientNumber: [
        (v) => v.length >= 4 || "Numret måste vara minst 4 tecken",
        (v) => !!v || "Du måste ange ett nummer",
      ],
      disableSendField: false,
      connectionUp: "idle",
      error: false,
      screenSharing: false,
      shiftPressed: false,
      width: window.innerWidth,
      height: window.innerHeight,
      mindDesign: config.customer.spacialDesignForMind,
      cfgNotify: config.customer.notification,
      emojiShow: false,
      chatQuit: 0,
      dialog1: false,
      changableChatMessageWindow: "chatWindow",
      agentIsWriting: false,
      mindLandingPage: true,
      interval: null,
      agentLeavOpenChat: false,
      isChatOpen: true,
      iHaveASlot: false,
      caseId: 0,
      quitChatInQueue: false,
      timeOut: 0,
      loaded: false,
      trackingGuid: localStorage.getItem('___user-guid')
    };
  },
  filters: {
    moment: function (date) {
      const d = moment(date);
      const TODAY = d.clone().startOf("day");

      if (d.isSame(TODAY, "d")) {
        return "Idag " + d.format("HH:mm");
      } else {
        return moment(date).format("YYYY-MM-DD HH:mm");
      }
    },
  },
  components: {
    ScreenShare,
    Survey
  },
  computed: {

    desktop() {
      return window.innerWidth > 600;
    },
    agentFullName() {
      return this.$props.user.name;
    },
    agentProfilePicture() {
      return this.$props.user.profileImageUrl;
    },
    bookingObject_() {
      return this.$props.booking;
    },
    restartScreenSharing() {
      return this.$store.state.restartScreen;
    },
  },
  watch: {

    messageFromVisitor(value) {
      this.onWriting(value);
    },
    screenSharing(value) {
      if (value === false) {
        this.messageFromVisitor = "Skärmdelningen är nu avslutad";
        this.sendMessage();
      }
    },
    restartScreenSharing(value) {
      this.screenSharing = false;
    },
    connectionUp(value) {
      if (value == "error") {
        this.error = true;
      } else {
        this.error = false;

        if (this.rand !== null) {
            this.startTheChat();
        }
      }
    },
    chatQuit() {
      this.changeChatWindowSize();
    },
    agentIsWriting() {
      var objDiv = document.getElementById("chatWindow");
      setTimeout(() => {
        objDiv.scrollTop = objDiv.scrollHeight - 50;
      }, 50);
    },
    mindLandingPage(val) {
      if(val === false && localStorage.getItem('clickNotification') != '1' && this.cfgNotify.active === true) {
          this.notify();
          localStorage.setItem('clickNotification',1)
      }
    }
  },
  sockets: {
    consentWithdrawn: function () {
      this.deleteCookie('accepted-rules')
      this.acceptedRules = false
    },
    reachedLimit: function () {
      this.dailyLimitReached = true
    },
    connect: function () {
      this.connectionUp = "idle";
    },
    connect_failed: function () {
      this.connectionUp = "error";
    },
    disconnect: function () {
      this.connectionUp = "error";
    },
    agentState: function(data) {
      if(data.state === "agentIsHere") {
        localStorage.setItem('agentWasHere', true)
        this.mindLandingPage = false;
        this.agentLeavOpenChat = false;
        this.postMessageAgentIsHere(data);
        if(this.caseId !== 0) {
          console.log("customer survey: ", config.customer.survey);
          if(!config.customer.survey.preSurvey.active) { return }
          this.$store.dispatch('triggSurvey',{type : 'pre' });
        }
      } else {
        if(localStorage.getItem('agentWasHere') != null) {
          this.agentLeavOpenChat = true;
        } else {
          this.agentLeavOpenChat = false;
        }
      }

    },
    state: function (data) {
      if(data.state === 'closed') { //Denna som orsakar reload
        this.quitChat();
        this.chatQuit = 1;
        this.iHaveASlot = false;
        console.log("Den chatt/kö-plats du hade blev stängd pga inaktivitet. Tryck OK för att försöka igen");
        setTimeout(() => {
          window.location.reload()
        }, 500);
        
      } else {
        this.iHaveASlot = false;
      }
    },
    emitToVisitor: function (data) {
      localStorage.setItem("rand", data);
      this.rand = data;
      this.caseId = data;
      if(data !== null) {
        this.iHaveASlot = true;
      }
    },
    chatIsNowClosed: function (data) {
      this.closePopup();
      this.quitChat()
    },
    clientWritingMessage: function (data) {
      clearInterval(this.interval)
      if (data > 0) {
        this.agentIsWriting = true;
        let self = this
        this.interval = setInterval(function() {
          self.agentIsWriting = false  
        }, 3000)
        // this.scrollToEnd();
      } else {
        this.agentIsWriting = false;
      }
    },
    messageObject: function (data) {
      if (data.length > 0) {
        if (data[0].message === "#ShareScreen") {
          this.screenSharing = true;
        }
      }

      this.messageObject = data.reverse();
      if (this.messageObject.length > 0) {
        if(this.messageObject[this.messageObject.length-1].clientEmail == 'AgentLeavOpenChat') {
          localStorage.setItem("agentLeave", true)
        }
      }

      var newArray = this.messageObject.filter(function (el) {
        return el.showOnlyForAgent == 0;
      });

      this.messageObject = newArray;

      var objDiv = document.getElementById("chatWindow");

      if(objDiv === null) return;

      setTimeout(() => {
        objDiv.scrollTop = objDiv.scrollHeight - 50;
      }, 50);
    },
    chatOpenState: function (data) { 
      this.isChatOpen = data;
      console.log("received chatOpenState: ", data);

      this.postMessageIsChatOpen(this.isChatOpen);
      console.log("checking if data is true and rand isnt null");
      if(data === true || this.rand != null) {
        console.log("settimeout to initAllStartParams");
        setTimeout(() => {
          let self = this;
            self.initAllStartParams(); // IF CHAT IS OPEN 
        }, 700);
         
      } else {
        console.log("quitting chat");
        this.quitChat();
      }
    },
    chatBusy: function(data) {
      alert("Något gick fel, stäng denna sida och försök att starta en chat igen.");
      let errorObject = {
        state: 'vId already exists',
        dateTime: new Date(),
        userAgent: navigator.userAgent || 'Unknown',
        visitorId: this.visitorId || 'Unknown',
        rand: this.rand || 'Unknown or null'
      }

      this.$socket.emit('errorHandler', errorObject);
      this.quitChat();
      this.initAllStartParams();
    }
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.vbChange);
  },
  created() {
    // checka först om cookien finns. Om den inte finns behöver vi inte kolla withdrawn_consents. Har man godkänt (och ej återkallat) finns cookien
    // checka om consent är withdrawn --> om msgid finns i withdrawn_consents => ta bort acceptedRules cookien i frontend, samt ta bort raden från withdrawn_consents
    // TODO: Comment in when consent is implemented
    this.acceptedRules = Boolean(this.getCookie('accepted-rules')) || false
    if (this.acceptedRules) {
      console.log("Consent exists, checking if consent is withdrawn or not");
      this.$socket.emit('consentCheck', this.userGuid);
    }
  },
  mounted() {
    window.addEventListener('visibilitychange', this.vbChange)
    this.changeChatWindowSize();
    console.log("mindDesign: ", this.mindDesign);
    console.log("mindLandingPage: ", this.mindLandingPage);
    console.log("loaded: ", this.loaded);
  },
  methods: {
    setCookie(name, value, days) {
      // Function to easily set a cookie
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
    },
    getCookie(name) {
      // Function to easily get a cookie
      const cookieName = encodeURIComponent(name) + "=";
      const cookieArray = document.cookie.split(";");

      for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i].trim();
        if (cookie.indexOf(cookieName) === 0) {
          return decodeURIComponent(cookie.substring(cookieName.length, cookie.length));
        }
      }
      return null;
    },
    deleteCookie(name) {
      // Function to easily delete a cookie
      document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    },
    acceptRules() {
      console.log("acceptRules function");
      if (this.conditionsCheckbox) {
        console.log("rules checkbox checked");
        this.acceptedRules = true
        this.setCookie('accepted-rules', this.acceptedRules, 90)
        this.startTheChat()
        // this.initAllStartParams() //this or startTheChat?
      } else {
        this.notAcceptedModal = true
      }
    },
    postMessageAgentIsHere(data) {
      // ** POST MESSAGE SEND TO PARENT IFRAME **/
  
        let obj = {
          msgType: 'chatState',
          state: {
            code: 201,
            type: 'softMessage',
            message: 'Agent entered the chat',
            caseId: this.caseId,
            namespace: config.customer.uniqueChat || 'UNKNOWN'
          }
        }

        console.log("chatState -> Debug -> ",obj);
        
        if(parent == null) {
          console.log("Could not find parent holde of iframe, return");
          return;
        }

        parent.postMessage(obj,"*");  //  `*` on any domain         
        
      // ** POST MESSAGE SEND TO PARENT IFRAME ** //
    },
    postMessageIsChatOpen(isChatOpen) {

      // ** POST MESSAGE SEND TO PARENT IFRAME **/
      console.log("isChatOpen",isChatOpen);

      if(this.rand != null) {
        console.log("ChatIsAlreadyOpen do not send softMessage to parent");
        return;
      }

      if(isChatOpen === false) {


        let obj = {
          msgType: 'chatState',
          state: {
            code: 403,
            type: 'softMessage',
            message: 'Chat was not available when predicted, try again'
          }
        }
        if(parent == null) {
          console.log("Could not find parent holde of iframe, return");
          return;
        }
        
        parent.postMessage(obj,"*");  //  `*` on any domain         
        
      }

      // ** POST MESSAGE SEND TO PARENT IFRAME ** //
    },
    vbChange(data) {
        if(document.visibilityState == 'visible') {
          console.log("Away from hidden -> ", new Date());
          this.$forceUpdate();
          this.initAllStartParams();
        }
    },
    notify() {
      let content = { title: `Nytt meddelande - ${config.company}`, body: ''}
      document.title = `Nytt meddelande - ${config.company}`
      let self = this

        if ('Notification' in window) {
          // API supported
        } else {
          // API not supported
          console.log("notif not supported");
          return;
        }


      if (window.Notification.permission !== 'granted') {
        window.Notification.requestPermission();
      } else {
        var notification = new Notification(content.title, {
          body: content.body,
          icon: this.cfgNotify.icon,
        });
        notification.onclick = function(event) {
          return;
          event.preventDefault()
          notification.close();
          document.title = self.cfgNotify.title
          window.open(self.cfgNotify.url, '_blank')
          // window.open('http://localhost:8080/', '_blank')
          // window.open('https://customerfirst.swyx.se/service-portal/service-worker/demo-lensway/', '_blank')
        };
      }
    },
    initAllStartParams() {
      console.log("initAllStartParams");
    if (this.bookingObject_) {
      console.log("bookingObject");
      this.startTheChat();
      this.addContactInfo = false;
      return;
    } else {
      if (config.customer.autostartChat == true) {
        console.log("autostartChat");
        this.visitorInfo = {
          visitorEmail: this.visitorId,
          visitorClientNumber: this.visitorId,
          visitorId: this.visitorId,
        };
        localStorage.setItem("visitorInfo", JSON.stringify(this.visitorInfo));
        this.addContactInfo = false;
        this.startTheChat();
        this.addContactInfo = false;
        this.loaded = true;
        console.log("loaded: ", this.loaded);
        console.log("finished initAllStartParams");
        return;
      }

      if (localStorage.getItem("visitorInfo") !== null) {
        this.visitorInfo = {
          visitorEmail: JSON.parse(localStorage.getItem("visitorInfo")).visitorEmail,
          visitorClientNumber: JSON.parse(localStorage.getItem("visitorInfo")).visitorClientNumber,
          visitorId: this.visitorId,
        };
        this.visitorEmail = this.visitorInfo.visitorEmail;
        if (
          this.rand == null
        ) {
          //this.addContactInfo = true;
        } else {
          if(this.mindDesign) {
            this.mindLandingPage = false
          }
       
          this.addContactInfo = false;
          this.startTheChat();
        }
      } else {
        this.addContactInfo = false;
      }
    }
    if (config.customer.requiredToGiveEmail == false) {
      this.addContactInfo = false;
    }
      this.loaded = true;
    },
    isAgentHere() {
      this.$socket.emit('presenceState', {status: 'iAmHere', question: 'areYouHere', rand: this.rand});
    },
    clearStorReload() {
      this.quitChat()
    },
    scrollToEnd() {
      var container = this.$el.querySelector("#chatWindow");
      var mindContainer = this.$el.querySelector("#chatWindow-mind");
      if (container !== null) {
        container.scrollTop = container.scrollHeight;
      } else {
        mindContainer.scrollTop = mindContainer.scrollHeight;
      }
    },
    emojiEvent: function (event) {
      let self = this;
      let valueNow = self.messageFromVisitor;
      if(valueNow == null || valueNow == undefined || valueNow == 'null' || valueNow == 'undefined') {
        valueNow = ''
      }
      let emoji = event.detail.unicode;
      self.messageFromVisitor = `${valueNow}${emoji}`;
      self.emojiShow = false;
    },
    handleDocumentClick(event) {
      document.title = this.cfgNotify.title
      localStorage.removeItem('clickNotification')
      if (event.target.id != "emojiToggleBtn" && event.target.id != "emojiToggleIcon") {
        this.emojiShow = false
      }
    },
    quitChat() {
      this.dialog1 = false;
      this.chatQuit = 1;
      localStorage.removeItem('clickNotification')

      if(this.rand  != null) {
        this.$socket.emit("chatClosed", {
          visitorId: this.visitorId,
          agentUserId: this.$props.user.userId,
          rand: this.rand,
          from: 'client',
          info: 'closedFromClient',
        });
    
      }
      this.$store.dispatch('triggSurvey',{type : 'post' });
      const tempGuid = localStorage.getItem('___user-guid');
      console.log("tempGuid", tempGuid)
      localStorage.clear();
      this.$socket.disconnect();
      localStorage.setItem('_lastClosed', moment().format("YYYY-MM-DD HH:mm"));
      this.rand = localStorage.getItem("rand");
      setTimeout(() => {
         localStorage.clear();
         localStorage.setItem("___user-guid",tempGuid)
      }, 600);

      localStorage.setItem("___user-guid",tempGuid)
      this.loaded = true;

    },
    closePopupLeavPage() {
      this.quitChat();
      this.disableSendField = true;

      if (config.customer.goToUrlOnClose == true) {
        window.parent.location.href = config.returnWebsite;
        
      } else {
        this.$store.dispatch("goBack");
      }
      this.dialog = false;
    },
    changeChatWindowSize() {
    
      if (
        (this.mindDesign == true && this.chatQuit == 0) ||
        (this.mindDesign == true && this.chatQuit == null)
      ) {
        this.changableChatMessageWindow = "chatWindow-mind";
      } else if (
        (this.mindDesign == true && this.chatQuit == 1) ||
        (this.mindDesign == true && this.chatQuit == "1")
      ) {
        this.changableChatMessageWindow = "full-size-chat-window";
      } else {
        this.changableChatMessageWindow = "chatWindow";
      }
    },
    getOnlyTime(time) {
       return moment(time).format('HH:mm');
    },
    onWriting(data) {
      this.$socket.emit("clientWriting", {
        message: data,
        rand: this.rand,
      });
    },
    scroll() {
      window.scrollTo(0, 0);
    },
    setBorderColor: function (presenceId) {
      const presence = parseInt(presenceId);
      return { "border-color": presenceColor.setPresenceColor(presenceId) };
    },
    startTheChat() {
      console.log("startTheChat, are the rules accepted: ", this.acceptedRules);
      if (this.acceptedRules != true) return

      localStorage.setItem('chatOpen', true)
      if (this.bookingObject_) {
        this.$socket.emit("chatOpen", this.bookingObject_);
      } else {
        if (
          this.rand == null
        ) {
          let mindTrackingGuid = this.trackingGuid;
          this.$socket.emit("chatOpen", {
            visitorId: this.visitorId,
            agentUserId: 0,
            fromAgent: false,
            visitorInfo: this.visitorInfo,
            userAgent: navigator.userAgent || 'Unknown',
            lang: navigator.language,
            iHaveASlot: this.iHaveASlot,
            dateTime: new Date(),
            queue: { ID: config.customer.uniqueChat || 'Tom guid', Name: config.customer.queueName || 'NoName' },
            trackingGuid: mindTrackingGuid || 'UNKNOWN'
          });
        } else {
          this.$socket.emit("continueChat", {
            visitorId: this.visitorId,
            agentUserId: 0,
            fromAgent: false,
            visitorInfo: this.visitorInfo,
            rand: this.rand,
            userAgent: navigator.userAgent || 'Unknown',
            lang: navigator.language,
            iHaveASlot: this.iHaveASlot,
            dateTime: new Date()
          });
          this.caseId = this.rand;
          this.iHaveASlot = true;

        }
      }
      this.isAgentHere();
    },
    addVisitorInfo() {
      this.visitorInfo = {
        visitorEmail: this.visitorEmail,
        visitorClientNumber: this.visitorClientNumber,
        visitorId: this.visitorId,
      };
      localStorage.setItem("visitorInfo", JSON.stringify(this.visitorInfo));
      this.addContactInfo = false;
      
      this.startTheChat();
    },
    sendKeyUp() {
      if (event.keyCode === 16) {
        this.shiftPressed = false;
      } else if (this.shiftPressed && event.keyCode == 13) {
        // new line
        this.shiftPressed = false;
      }
    },
    sendKeyDown() {
      if (event.keyCode === 16) {
        this.shiftPressed = true;
      } else if (event.keyCode === 13 && this.shiftPressed === false) {
        event.preventDefault();
        this.sendMessage();
      }
    },
    sendMessage() {
      // Check if message is empty from customer
   
      if (this.messageFromVisitor == null) {
        alert("Du måste skriva något");
        return;
      } 

      if(this.messageFromVisitor.length === 0) {
        alert("Du måste skriva något");
        return;
      }

      if(this.rand == null) {
        alert("Något har blivit tokigt, testa att ladda om sidan, eller starta en ny chat");
        this.$socket.emit("errorHandler", { userAgent: navigator.userAgent, localStorage: localStorage, dateTime: new Date(), func: 'sendMessage' });
        return;
      }
      // Create the object to send to server
      const tempInteractionObject = {
        visitorId: this.visitorId,
        agentFullName: this.agentFullName,
        agentUserId: this.$props.user.userId,
        message: this.messageFromVisitor,
        rand: this.rand,
        from: "client",
        clientEmail: this.visitorInfo.visitorEmail,
      };
      
      this.$socket.emit("sendMessage", tempInteractionObject);
      // After sending clear the input field and the string
      this.$refs.messageRef.clearableCallback();
      this.scrollToEnd();
    },
    callClosePopup() {
      this.chatQuit = 0;
      this.closePopup();
        let obj = {
          msgType: 'windowInteractionExit',
          state: {
            code: 499,
            type: 'softMessage',
            message: 'Chat closed button is pressed'
          }
        }
        
        if(parent == null) {
          console.log("Could not find parent holde of iframe, return");
          return;
        }

        parent.postMessage(obj,"*");  //  `*` on any domain   
    },
    closePopup() {
      // Leaving chat
      if (localStorage.getItem('chatOpen') != 'true') {
        localStorage.removeItem('chatOpen')
        localStorage.removeItem("rand");
     
        this.disableSendField = true;

        if (config.customer.goToUrlOnClose == true) {
          //window.parent.location.href = config.returnWebsite;
        } else {
          this.$store.dispatch("goBack");
        }
        this.dialog = false;
      }
    },
  },
};
</script>

<style scoped>

.conditions-div {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: auto;
  width: 90%;
  max-width: 769px;
  max-height: 80vh;
  border-radius: 10px;
  background-color: #e7e7e761 
}

.conditions-div > header {
  padding: 1em;
  background-color: orange;
  width: 100%;
  text-align: left;
  border-radius: 10px 10px 0 0
}

.conditions-div > .condition-content {
  max-height: 500px;
  overflow-y: scroll;
  text-align: left;
  padding-top: 1em;
}

.condition-content-text {
  padding: 0 1em;
}

.conditions-list {
  text-align: left;
  list-style-type:
  none;background-color: #80808014;
  padding: 1em 1em 1em 24px;
  margin: 1em;
}

ul li:before {
  content: "\2022";
  color: #FFA500;
  font-weight: bold;
  font-size: 1.2em;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
}

.options {
  display: flex;
  justify-content: center;
  gap: 1em;
  align-items: center;
}

.not-accepted-modal {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 400px;
}

.not-accepted-modal > header {
  height: 30px;
  background-color: orange;
}

input[type="text"] {
  font-size: 16px !important;
}
pre {
  font-family: inherit;
}
.chatWindow {
  overflow-x: hidden;
  width: 100%;
  height: 55vh;
  display: block;
  overflow: scroll;
}

/* this would be nice if you can add a function that pushes up the textarea & send button when the mobile keyboard is up  */
/* @media only screen and (min-device-width : 320px) and (max-device-width : 480px) { 
  .chatWindow {
    height: 75vh;
    }
} */

.message-from-visitor {
  background-color: #006eb0;
  display: inline-block;
  max-width: 40%;
  margin: 10px;
  font-size: 12px;
  padding: 10px;
  border-radius: 10px;
  color: white;
  word-wrap: break-word;
  white-space: -moz-pre-wrap;
  white-space: pre-wrap;
}

.message-from-agent {
  background-color: rgb(245, 245, 245);
  display: inline-block;
  max-width: 40%;
  margin: 10px;
  font-size: 12px;
  padding: 10px;
  border-radius: 10px;
  color: black;
  word-wrap: break-word;
  white-space: -moz-pre-wrap;
  white-space: pre-wrap;
}
.close-chat-btn {
  float: right;
  margin-right: 10px;
  font-size: 30px;
  cursor: pointer;
}
.mind-logo-container {
  position: absolute;
  top: 20px;
  left: 20px;
  height: 50px;
  width: 44px;
}
.message-creation-container {
  width: 100%;
  height: 70px;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 10px;
}
.message-creation-textarea-container {
  float: left;
  width: 80%;
  font-size: 1em;
}
.message-creation-textarea {
  float: left;
  width: 100%;
  white-space: pre-line;
}
.message-creation-send-btn {
  width: 10%;
  padding-top: 15px;
}

.before-chat-login {
  width: 100%;
  height: 320px;
  padding: 20px;
  z-index: 9;
  background-color: white;
}
.before-chat-login-mind {
  width: 100%;
  height: 320px;
  padding: 20px;
  z-index: 9;
  background-color: white;
  margin-top: 75px;
}
.sure-to-quit-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  height: 60%;
}

/* --- special styling for mind --- */

.header-logo-mind {
  width: 100%;
  font-size: 11px;
  margin-top: 10px;
  height: 10vh;
}

.message-from-visitor-mind {
  background-color: #0c9896;
  display: inline-block;
  max-width: 40%;
  margin: 5px;
  margin-bottom: 10px;
  font-size: 12px;
  padding: 10px;
  border-radius: 10px;
  color: white;
  word-wrap: break-word;
  white-space: -moz-pre-wrap;
  white-space: pre-wrap;
  text-align: left;
}
.message-from-agent-mind {
  background-color: #f7e2c6;
  display: inline-block;
  max-width: 40%;
  margin: 5px;
  margin-bottom: 10px;
  font-size: 12px;
  padding: 10px;
  border-radius: 10px;
  color: black;
  word-wrap: break-word;
  white-space: -moz-pre-wrap;
  white-space: pre-wrap;
  text-align: left;
}

.chatWindow-mind {
  overflow-x: hidden;
  width: 100%;
  height: 45vh;
  display: block;
  overflow: scroll;
}

.full-size-chat-window {
  overflow-x: hidden;
  width: 100%;
  height: 53vh;
  display: block;
  overflow: scroll;
}

.message-creation-container-mind {
  width: 100vw;
  height: 44vh;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.message-creation-btn-container-mind {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-right: 4%;
}
.message-creation-textarea-container-mind {
  width: 95vw;
  font-size: 1em;
}
.message-creation-textarea-mind {
  float: left;
  width: 100%;
  white-space: pre-line;
}
/* .message-creation-send-btn-mind {
} */
.back-to-home-btn-mind {
  color: white;
}

  @media screen and (max-width: 769px) {

  .conditions-div {
    overflow-y: scroll;
    width: 100%;
    height:100dvh; /* this was 100vh before */
    max-height: none;
    position: absolute;
    top: 0;
    border-radius: 0;
  }

  .conditions-div::-webkit-scrollbar,.conditions-div > .condition-content::-webkit-scrollbar {
    display: none;
  }

    /* Hide scrollbar for IE, Edge and Firefox */
  .conditions-div,.conditions-div > .condition-content {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }

  .conditions-div > header {
    border-radius: 0;
  }

  .conditions-div > .condition-content {
    max-height: none;
  }
  .conditions-div > .condition-content > ul {
    margin: 1em 0;
  }
}

  @media screen and (max-width: 600px) {

    .options {
      flex-direction: column;
      gap: 0;
      
    }
    .options > button {
      width: 100%;
      border-radius: 0;
      /* max-width: 300px; */
    }
  }

@media only screen and (max-height: 36em) {
  .header-logo-mind {
    height: 15vh;
  }
  .message-creation-container-mind {
    height: 40vh;
  }
}
.welcome-text-container {
  margin-top: 100px;
  height: 40vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qiut-btn-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  bottom: 0;
  left: 0;
  height: 100px;
  width: 100%;
}
.hr-for-qiut-btn-container {
  width: 90vw;
  margin-right: 5vw;
  margin-bottom: 5px;
}
.qiut-btn {
  color: white;
  float: right;
  margin-right: 5vw;
}
.sure-to-quit-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  height: 60%;
}
.welcome-text-container {
  margin-top: 100px;
  height: 40vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
